import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';

export class FascicoloCoTerzi extends FascicoloFull {
  sezione: string;
  valorePrecetto: number | string;
  numRuoloDecretoRif: string;
  posizioneFascicoloRif: string;
  dataInizioFascicoloRif: number;
  constructor() {
    super();
    this.dataInizioFascicolo = + new Date();
  }
}
